import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { skipWhile } from 'rxjs/operators';

import { BuyerService } from '../../../core/api/buyer.service';
import { SiteService } from '../../../core/api/site.service';
import { FormatHelperService } from '../../../core/helper/format-helper.service';
import { SiteHelperService } from '../../../core/helper/site.service';
import { StatusEnum } from '../../../shared/constants/site_status.enum';
import { Site } from '../../../shared/models';
import * as fromApp from '../../../store';
import { getDocuments } from '../../../store/document/document.actions';
import { clearActiveSite, setActiveSite } from '../../../store/site/site.actions';
import { selectActiveSite } from '../../../store/site/site.selectors';

@Component({
  selector: 'fc-site-detail-page',
  templateUrl: './site-detail-page.component.html',
  styleUrls: ['./site-detail-page.component.scss'],
})
export class SiteDetailPageComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  id: number = null;
  site: Site = null;
  valuePerYear: string;
  showReportDisturbanceButton: boolean = false;
  showReportPeriodicButton: boolean = false;

  getOpenAssetURL = BuyerService.getOpenAssetURL;

  constructor(
    readonly store: Store<fromApp.AppState>,
    readonly formatHelper: FormatHelperService,
    readonly siteHelper: SiteHelperService,
    readonly router: Router,
    readonly route: ActivatedRoute,
    readonly siteService: SiteService
  ) {
    this.id = +this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.store.dispatch(clearActiveSite());
    this.store.dispatch(setActiveSite({ id: this.id }));
    this.store
      .select(selectActiveSite)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        skipWhile(site => site === null)
      )
      .subscribe(activeSite => {
        this.site = activeSite;
        this.valuePerYear = this.formatHelper.formatMinMaxValuation(this.site.getAverageAnnualRevenue());
        this.showReportDisturbanceButton = this.site.activationDate !== null;
        this.showReportPeriodicButton = this.site.status === StatusEnum.REPORTING_REQUIRED;
        this.store.dispatch(getDocuments({ identifier: this.site.identifier }));
      });
  }

  reportDisturbance() {
    this.router.navigateByUrl(`/account/site/${this.site.id}/report-response?reportType=Disturbance`);
  }

  reportPeriodic(): void {
    this.router.navigateByUrl(`/account/site/${this.site.id}/report-response`);
  }
}
